/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Tool_Result_Content_Reference_UnavailableInputs */



/**
* | output |
* | --- |
* | "The referenced content is not available in this chat" |
*
* @param {Chat_Tool_Result_Content_Reference_UnavailableInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_tool_result_content_reference_unavailable = /** @type {((inputs?: Chat_Tool_Result_Content_Reference_UnavailableInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Tool_Result_Content_Reference_UnavailableInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Der referenzierte Inhalt ist in diesem Chat nicht verfügbar")
	return /** @type {LocalizedString} */ ("The referenced content is not available in this chat")
});